import { render, staticRenderFns } from "./UserBehaviorReport.vue?vue&type=template&id=4479fd1d&scoped=true"
import script from "./UserBehaviorReport.vue?vue&type=script&lang=js"
export * from "./UserBehaviorReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4479fd1d",
  null
  
)

export default component.exports